import React, { useEffect } from "react";
import "./staking.scss";
import { Accordion, Modal } from "react-bootstrap";
import { useState } from "react";
import Navbar from "../landing/header/Navbar";
import moment from "moment";
import axios from "axios";
import Environment from "../../utils/Environment";
import GetGemsBalance from "../../hooks/chinaFunction/getGemsBalance";
import GetGemsStaked from "../../hooks/chinaFunction/getGemsStakeAmount";
import StakeGems from "../../hooks/chinaFunction/stakeGems";
import UnStakeGems from "../../hooks/chinaFunction/unstakeGems";
import AllowanceGems from "../../hooks/chinaFunction/allowanceGems";
import ApproveGems from "../../hooks/chinaFunction/approveGems";
import GetGemsStakedIndex from "../../hooks/chinaFunction/getGemsStakedIndex";
import { toast } from "react-toastify";
import { useWeb3React } from "@web3-react/core";
import Loader from "../../hooks/loader";
import { useHistory } from "react-router-dom";
import CuurentRound from "../../hooks/chinaFunction/round";
import { logDOM } from "@testing-library/react";
import { Api_Url, Api_Url_Premium } from "../../utils/ApiUrl";
import { setupNetwork } from "../../utils/wallet";
import { TOKENS } from "../../utils/Constants";
import useWeb3 from "../../hooks/useWeb3";
import { requestWithState } from "../../@api/requestWithState";
import { useTranslation } from "react-i18next";
import { switchChain } from "../../utils/chains/switchChain";
// import useAutoChainSwitch from "../../hooks/useAutoChainSwitch";
const Staking = () => {
  // useAutoChainSwitch(1)
  const { t } = useTranslation();
  let round = localStorage.getItem("currentRunningRound");
  let countryBuyer = localStorage.getItem("country");
  const { cuurentRound } = CuurentRound();
  const history = useHistory();
  const { account, chainId } = useWeb3React();
  console.log(chainId, 'chainId')
  const { GetGemsBal } = GetGemsBalance();
  const { getGemsStaked } = GetGemsStaked();
  const { stakeGems } = StakeGems();
  const { unstakeGems } = UnStakeGems();
  const { allowanceGems } = AllowanceGems();
  const { approveGems } = ApproveGems();
  // const { getGemsStakedIndex } = GetGemsStakedIndex();
  const web3 = useWeb3();

  const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState(false);
  const [amount, setAmount] = useState(400);
  const [amountError, setAmountError] = useState("");
  const [walletError, setWalletError] = useState("");
  const [stakeIndex, setStakeIndux] = useState(null);
  const [stakeIndex1, setStakeIndux1] = useState(null);

  const [balance, setBalance] = useState(0);
  const [allowance, setAllowance] = useState(0);

  const [minStakeAmount, setMinStakeAmount] = useState(999999999999999);
  const [stakingGasFees, setStakingGasFees] = useState(0);
  const [stakedAmount, setStakedAmount] = useState(0);

  const [showverify, setShowVerify] = useState(false);
  const handleCloseVerify = (flag) => {
    if (flag) {
      setShow1(true);
    }
    setEmail("");
    setOtp("");
    setIsOtpValid(true);
    setShowVerify(false);
  };
  const handleShowVerify = () => setShowVerify(true);

  // const [stakeEndTime, setStakeEndTime] = useState([]);
  // const [stakeEndTime1, setStakeEndTime1] = useState([]);
  // const [stakingData, setStakingData] = useState([]);
  // const [stakingData1, setStakingData1] = useState({});

  const [subscriptionEndTime, setSubscriptionEndTime] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState([]);

  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);

  const [country, setCountry] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(10); // Define how many items to show per page
  const [orderBy, setOrderBy] = useState("blockTimestamp");
  const [orderDirection, setOrderDirection] = useState("asc");
  const [gemsPrice, setGemsPrice] = useState(0);
  const [show1, setShow1] = useState(false);
  const [show_Nav, setShow_Nav] = useState(false);

  const handleClose = () => setShow1(false);
  const handleShow = () => {
    if (!verified) {
      handleShowVerify();
    } else {
      setShow1(true);
    }
  };

  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => {
    setShow3(false);
    window.location.assign("/buy");
  };

  const [token, setToken] = useState(TOKENS[0]);
  const [isPremium, setIsPremium] = useState(false);

  const [verified, setVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(true);
  const [email, setEmail] = useState("");

  const handleClose1 = () => {
    handleShow5();

    setShow2(false);
    // window.location.assign("/buy");
  };
  const handleShow1 = () => {
    setShow2(true);
  };

  const modalTwitter = localStorage?.getItem("twittter");
  const [show5, setShow5] = useState(false);
  const handleClose5 = () => {
    setShow5(false);
    // localStorage.setItem("twittter", true);
  };
  const handleShow5 = () => setShow5(true);

  const twitterHandler = () => {
    const weChatShareUrl = "https://x.com/Gems_VIP_";

    // Open the WeChat share link in a new window
    window.open(weChatShareUrl, "_blank");
    handleClose5();
  };

  // useEffect(() => {
  //   if (!modalTwitter) {
  //     handleShow5();
  //   }
  // }, []);

  const getGemsPrice = async () => {
    try {
      const config = {
        method: "get",
        url: `${Api_Url_Premium}/users/gems-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        // console.log(response,'response');
        let qw = response?.data?.data;
        setGemsPrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };
  const checkIsPremium = async () => {
    try {
      const response = await requestWithState({
        url: `/credit/ispremium`,
        method: "POST",
        data: { walletAddress: account.toLowerCase() },
      });

      if (response?.data?.isPremiumUser) {
        setIsPremium(true);
        console.log("Premium fetched successfully:", response?.data);
        return true;
      } else {
        setIsPremium(false);
        console.log("User is not premium");
        return false;
      }
    } catch (error) {
      setIsPremium(false);
      console.error("Error checking premium:", error);
      return false;
    }
  };

  useEffect(() => {
    if (account && country) {
      checkVerification();
    }
  }, [account, country]);
  // const fetchStakingData = async () => {
  //     setLoader1(true)
  //     try {
  //         const response = await axios.post(
  //             "https://api.studio.thegraph.com/query/63987/staking-gems-testnet/12",
  //             {
  //                 query: `
  //             query MyQuery($staker: String, $isClaimed: Boolean,) {
  //               stakeds(where: {staker: $staker}, isClaimed: $isClaimed,) {

  //                 blockTimestamp
  //                 stakeEndTime
  //                 isClaimed
  //               }
  //             }`,
  //                 variables: {
  //                     staker: account,
  //                 },
  //             },
  //             {
  //                 headers: {
  //                     "Content-Type": "application/json",
  //                 },
  //             }
  //         );

  //         const resData = response.data.data.stakeds;
  //         if(resData.length>0){
  //         console.log(resData[0], 'resData');
  //         // setStakeIndux(parseInt(resData[0]?.stakerStakeIndex))
  //         setStakingData(resData);
  //         const currentTime = moment();
  //         const endTimeStampInSeconds = parseInt(
  //             resData[resData?.length - 1]?.stakeEndTime
  //         );
  //         const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
  //         if (!endTimeStamp.isValid()) {
  //             setStakeEndTime(currentTime);
  //         } else {
  //             setStakeEndTime(endTimeStamp);
  //         }
  //         setLoader1(false)
  //     }
  //     } catch (error) {
  //         console.error("Error fetching staking data: ", error);
  //         setLoader1(false)
  //     }
  // };

  const fetchSubscriptionData = async (useV2 = false) => {
    setLoader(true);

    const graphURL = useV2
      ? Environment.GemsSubscriptionGraph_v2
      : Environment.GemsSubscriptionGraph;

    console.log(graphURL, "Graph URl");

    const data = JSON.stringify({
      query: `query MyQuery {
      subscribeds(where: {by:  "${account}"}, orderBy: blockTimestamp, orderDirection: desc) {
        blockTimestamp
        blockNumber
        amountPurchased
        by
        endTime
        id
        tokenPrice
        transactionHash
      }
    }`,
      variables: {},
    });

    const config = {
      method: "post",
      url: graphURL,
      headers: {
        "Content-Type": "application/json",
        "x-api-key": Environment.GemsSubscriptionGraphKey,
      },
      data: data,
    };

    try {
      const response = await axios(config);
      const resData = response.data.data.subscribeds;
      // If no data and not already using v2, retry with v2
      if ((!resData || resData.length === 0) && !useV2) {
        return fetchSubscriptionData(true);
      }
      console.log(resData, "Res Data");
      if (resData.length > 0) {
        setSubscriptionData(resData);

        const currentTime = moment();
        const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
        const endTimeStamp = moment(endTimeStampInSeconds * 1000);

        console.log("subscription end time: ", currentTime, endTimeStamp);

        if (!endTimeStamp || currentTime.isAfter(endTimeStamp)) {
          if (!useV2) {
            // Re-fetch with v2 if not already using it
            return fetchSubscriptionData(true);
          } else {
            setSubscriptionEndTime(currentTime); // fallback if still no valid endTime
          }
        } else {
          setSubscriptionEndTime(endTimeStamp);
        }
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error, "error");
    }
  };
  const fetchStakingData = async () => {
    try {
      const response = await axios.post(
        Environment?.GemsStakingGraph,
        {
          query: `
            query MyQuery($staker: String, $isClaimed: Boolean,) {
              stakeds(where: {staker: $staker}, isClaimed: $isClaimed,) {
              
                stakerStakeIndex
          transactionHash
          stakeEndTime
          staker
          isClaimed
          id
          blockTimestamp
          blockNumber
          amount
              }
            }`,
          variables: {
            staker: account,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const resData = response.data.data.stakeds;
      console.log(resData, "Res Data")
      setStakeIndux(parseInt(resData[0]?.stakerStakeIndex));
      setStakingData(resData);

      const currentTime = moment();
      const endTimeStampInSeconds = parseInt(
        resData[resData?.length - 1]?.stakeEndTime
      );
      const endTimeStamp = moment(endTimeStampInSeconds * 1000);
      console.log("stake time: ", currentTime, endTimeStamp);

      if (!endTimeStamp.isValid()) {
        setStakeEndTime(currentTime);
      } else {
        setStakeEndTime(endTimeStamp);
      }
    } catch (error) {
      console.error("Error fetching staking data: ", error);
    }
  };

  const unstake = async (index) => {
    setLoader(true);
    // console.log([index], '[index]');
    try {
      const gas = await unstakeGems(account, index);
      if (gas) {
        // handleShow1();
        setLoader(false);
        getGemsStakedAmount();
        setShow3(true);
        setTimeout(() => {
          fetchStakingData();
          fetchSubscriptionData();
        }, 5000);
      }
    } catch (e) {
      setLoader(false);
      console.error(e);
      toast.error(e?.message);
    }
  };

  const Stake = async () => {
    let tokenBalance = await getGemsBalanceFunc(token);
    const token_Price = await getPrice(token?.NAME);
    let token_allowance = await getAllowance(token);
    setLoader(true);
    try {
      let config = {
        method: "post",
        url: `${Api_Url_Premium}/users/buy-premium-subscription`,
        data: {
          tokenSelected: token.NAME,
          walletAddress: account,
          country: country,

          // walletAddress: account.toLocaleLowerCase(),
          // country: countryBuyer,
          // type: "NODE",
          // tokenSelected: selectedToken?.mainTag,
        },
      };
      let postApiRes = await axios(config)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          setLoader(false);
          toast.error(error?.response?.data.message);
          // setLoarder(false);
        });
      if (postApiRes) {
        if (tokenBalance >= amount / token_Price) {
          if (
            token?.NAME === "ETH" ||
            token_allowance >= amount / token_Price
          ) {
            try {
              setLoader(true);
              let subAmount = amount / token_Price;
              console.log(
                subAmount,
                "amount / token_Priceamount / token_Price"
              );
              // Add 2 percent to subAmount
              const increasePercentage = 0.02;

              subAmount = subAmount * (1 + increasePercentage);
              let increasedAmount = subAmount * 10 ** token?.decimals;
              console.log(
                increasedAmount,
                "amount / token_Priceamount / token_Price"
              );

              const gas = await stakeGems(
                postApiRes,
                account,
                token,
                increasedAmount
              );
              console.log("gas: ", gas);

              if (gas) {
                // stakeAPI(gas?.transactionHash, gas?.timestamp);
                handleClose();
                handleShow1();
                setLoader(false);
                getGemsStakedAmount();
                getGemsBalanceFunc(token);
                setTimeout(() => {
                  fetchSubscriptionData();
                }, 5000);

                // setStakingGasFees(gas);
                // handleShow();
              }
            } catch (e) {
              // console
              setLoader(false);
              console.error(e);
              toast.error(e?.message);
            }
          } else {
            try {
              setLoader(true);
              // amount / token_Price
              const approve = await approveGems(
                account,
                tokenBalance,
                token?.tokenAddress,
                token?.decimals
              );
              if (approve) {
                getAllowance(token);
                let tokenBalance = await getGemsBalanceFunc(token);
                if (tokenBalance >= amount) {
                  try {
                    let subAmount = amount / token_Price;
                    const gas = await stakeGems(
                      postApiRes,
                      account,
                      token,
                      subAmount
                    );
                    console.log("gas: ", gas);
                    if (gas) {
                      // stakeAPI(gas?.transactionHash, gas?.timestamp);
                      handleClose();
                      handleShow1();
                      setLoader(false);
                      getGemsStakedAmount();
                      getGemsBalanceFunc(token);

                      setTimeout(() => {
                        fetchStakingData();
                        fetchSubscriptionData();
                      }, 5000);

                      // setStakingGasFees(gas);
                      // handleShow();
                    }
                  } catch (e) {
                    setLoader(false);
                    console.error(e);
                    toast.error(`Not Enough ${token?.NAME} Balance`);
                  }
                } else {
                  // handleShow2();
                  setLoader(false);
                  toast.error(`Not Enough ${token?.NAME} Balance`);

                  setWalletError(`Not Enough ${token?.NAME} Balance`);
                }
              }
            } catch (e) {
              setLoader(false);
              handleClose();
              console.error(e);
              toast.error(e?.message);
            }
          }
        } else {
          setLoader(false);
          handleClose();
          // handleShow2();
          toast.error(`Not Enough ${token?.NAME} Balance`);
          // setWalletError(`Not Enough ${token?.NAME} Balance`);
        }
      }
    } catch (err) {
      console.log(err, "in stake ");
      setLoader(false);
      handleClose();
      // toast.error(`Not Enough ${token?.NAME} Balance`);
    }
  };

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);

    if (staked !== null || staked !== undefined) {
      setStakedAmount(staked);
    }
  };

  const getAllowance = async (token) => {
    if (token?.NAME === "ETH") {
      setAllowance(0);
      return 0;
    }
    const all = await allowanceGems(
      account,
      token?.tokenAddress,
      token?.decimals
    );
    if (all !== null || all !== undefined) {
      setAllowance(all);
      return all;
    } else {
      return 0;
    }
  };

  const getGemsBalanceFunc = async (token) => {
    const { tokenAddress, decimals, NAME } = token;

    try {
      let bal;

      if (NAME === "ETH") {
        const balanceInWei = await web3.eth.getBalance(account);
        bal = web3.utils.fromWei(balanceInWei, "ether");
        bal = parseFloat(bal).toFixed(4);
      } else {
        bal = await GetGemsBal(account, tokenAddress, decimals);
      }

      if (bal !== null && bal !== undefined) {
        setBalance(bal);
        return bal;
      } else {
        setBalance(0);
        return 0;
      }
    } catch (error) {
      console.error("Error getting token balance:", error);
      setBalance(0);
      return 0;
    }
  };

  //  const StakeIndec=async()=>{
  //     const bal = await getGemsStakedIndex(account);
  //     console.log(bal, 'bal');
  //     if (bal !== null || bal !== undefined) {
  //         setStakeIndux(parseInt(bal)-1)
  //     }
  //  }

  useEffect(() => {
    if (account) {
      get_ApiKeys();
      // StakeIndec()
      // getGemsPrice();
      // getAllowance();
      // getGemsBalanceFunc();
      checkIsPremium();
      fetchStakingData();
      fetchSubscriptionData();
      getGemsStakedAmount();
    }
  }, [account]);

  async function getPrice(token) {
    try {
      const response = await fetch(`${Api_Url}/users/prices?token=${token}`);
      const data = await response.json();

      // Assuming the API returns something like { price: 25.43 }
      return parseFloat(data.data.data)?.toFixed(4);
    } catch (error) {
      console.error("Error fetching price:", error);
      return null;
    }
  }

  const checkVerification = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/wallet-details`,
        method: "POST",
        data: {
          country: country,
          by: account.toLowerCase(),
        },
      });

      console.log(response, "Verification Response");
      if (response?.deta?.isVerified) {
        setVerified(true);
        console.log("Verified fetched successfully:", response?.data);
        // setEmail(response?.deta?.email)
      } else {
        setVerified(false);
        console.log("User is not verified");
      }
    } catch (error) {
      setVerified(false);
      console.error("Error checking premium:", error);
    }
  };

  const get_ApiKeys = async () => {
    // let ipp=localStorage.getItem('ip')
    try {
      const response = await axios({
        method: "get",
        url: "https://ip.nf/me.json",
      });
      //  console.log(ipp,'response', response?.data.ip.ip);
      // if (!ipp||ipp!=response?.data.ip.ip){
      // localStorage.setItem('ip', response?.data.ip.ip)
      get_ApiKeys1(response?.data.ip.ip);
      // }
    } catch (error) {
      // setShowService(false)
      console.log(error, "error");
      // localStorage.setItem('ip',response?.data.ip)
      // localStorage.setItem('country',response?.data.country)
      // throw error;
    }
  };

  const get_ApiKeys1 = async (e) => {
    try {
      const response = await axios({
        method: "get",
        url: `https://api.iplocation.net/?ip=${e}`,
      });
      //  console.log(response?.data.country_name,'sdsdsdsds',);
      // localStorage.setItem('ip', response?.data.ip.ip)
      setCountry(response?.data.country_name?.toLowerCase());
      // setCountryyName(response?.data.ip.country)
      if (
        response?.data.country_name?.toLowerCase()?.includes("southsudan") ||
        response?.data.country_name?.toLowerCase()?.includes("south sudan") ||
        response?.data.country_name?.toLowerCase()?.includes("afghanistan") ||
        response?.data.country_name?.toLowerCase()?.includes("yemen") ||
        response?.data.country_name?.toLowerCase()?.includes("myanmar") ||
        response?.data.country_name?.toLowerCase()?.includes("unitedstates") ||
        response?.data.country_name?.toLowerCase()?.includes("united states") ||
        response?.data.country_name?.toLowerCase()?.includes("iran") ||
        response?.data.country_name?.toLowerCase()?.includes("north korea") ||
        response?.data.country_name?.toLowerCase()?.includes("syria") ||
        response?.data.country_name?.toLowerCase()?.includes("lebanon") ||
        response?.data.country_name?.toLowerCase()?.includes("northkorea") ||
        response?.data.country_name?.toLowerCase()?.includes("america") ||
        response?.data.country_name?.toLowerCase()?.includes("usa")
      ) {
        // setShowService(true)
      }
      //  }
      else {
        // setShowService(false);
      }
    } catch (error) {
      // setShowService(false)
      setCountry("india");

      console.log(error, "error");
      // localStorage.setItem('ip',response?.data.ip)
      // localStorage.setItem('country',response?.data.country)
      // throw error;
    }
  };

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsEmailValid(isValidEmail(value));
  };

  const [timer, setTimer] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setTimeout(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [timer, isResendDisabled]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    if (!isEmailValid || isResendDisabled) return;

    try {
      const response = await requestWithState({
        url: `/emails/verify-email`,
        method: "POST",
        data: {
          email,
          by: account.toLowerCase(),
          country,
        },
      });

      console.log(response);
      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        setShowOtpInput(false);
        handleCloseVerify(true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        toast.success("Verification email sent.");
        setShowOtpInput(true);

        // Start cooldown
        setIsResendDisabled(true);
        setTimer(10);
      } else if (response?.statusCode === 409) {
        toast.error("Email already exists");
      }
      else if (response?.statusCode === 403) {
        toast.error("Given wallet address is associated with existing email")
      }
    } catch (error) {
      console.error("Failed to send verification email:", error);
      // toast.error(error.message)
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email,
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        setVerified(true);
        console.log("Email verified successfully");
        setIsOtpValid(true);
        handleCloseVerify(true);
      } else {
        setIsOtpValid(false);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setIsOtpValid(false);
    }
  };

  // useEffect(() => {
  //   const switchIfNeeded = async () => {
  //     try {
  //       if (chainId && chainId !== 11155111) {
  //         await switchChain(11155111, 7);
  //       }else{
  //         // toast.info("You are on the correct network");
  //       }

       
  //     } catch (error) {
  //       console.error("Error switching network:", error);
  //       // toast.error("Failed to switch network");
  //       // setLoading(false);
  //     }
  //   };

   
  //     switchIfNeeded();
    
  // }, [account, chainId]);
  return (
    <>
      {/* {loader1 && <Loader />} */}
      {loader && (
        // <Loader text={"Please wait, your transaction is in process"} />
        <Loader text={""} />
      )}
      <Navbar show_Nav={show_Nav} setShow_Nav={setShow_Nav} />

      <section className="main-staking">
        <div className="upperbanner">
          <div className="custom-container">
            <h6 className="staketoppara">{t("GemsPremium")}</h6>
            <h4 className="stakemainhead">
              {t("pre1")} <span className="newertext">{t("pre2")}</span>
            </h4>
            <p>{t("pre3")}</p>
          </div>
        </div>
        <div className="lowerbanner">
          <div className="custom-container">
            <div className="newboxes-twice">
              <div className="single-box">
                <div className="upper-content">
                  <h6>{t("pre4")}</h6>
                  <h4>
                    <span>$0</span>
                  </h4>
                </div>
                <div className="bottom-content">
                  <div className="inner-single singlearea">
                    <div
                      className="text"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <p style={{ color: "var(--btn-green-bg)" }}>
                        {t("Footernew8")}
                      </p>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>{t("pre5")}</p>
                    </div>
                    <div className="text">
                      <span className="redtext">0%</span>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>{t("pre6")}</p>
                    </div>
                    <div className="text">
                      <span className="redtext">0%</span>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>
                        {t("pre7")}{" "}
                        <span className="orange-text">{t("Cryptot5")}</span>
                      </p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>
                        {t("CreditRefund")}{" "}
                        <span className="orange-text">{t("Cryptot5")}</span>
                      </p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single singlearea">
                    <div
                      className="text"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <p style={{ color: "var(--btn-green-bg)" }}>Trade</p>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>{t("pre8")}</p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p> {t("pre9")}</p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>{t("pre10")}</p>
                    </div>
                    <div className="text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <path
                          d="M14.2979 0.500023L11.4121 0.500023L7.49767 7.49266L10.3834 7.49266L14.2979 0.500023Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M14.2979 14.5L11.4121 14.5L7.49767 7.50737L9.31641 6.29848L10.3834 7.50737L14.2979 14.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 0.5L3.58791 0.500001L7.50233 7.49264L4.61656 7.49264L0.702148 0.5Z"
                          fill="#FC4F52"
                        />
                        <path
                          d="M0.702148 14.5L3.58791 14.5L7.50233 7.50737L5.68359 6.29848L4.61656 7.50737L0.702148 14.5Z"
                          fill="#FC4F52"
                        />
                      </svg>
                    </div>
                  </div>
                </div>


                {!account ||
                  (subscriptionData?.length > 0) ||
                  (stakingData?.length > 0 && stakingData[0]?.isClaimed === false || isPremium)
                  ? null : (
                    <a className="btn-plan" style={{ marginTop: "30px" }}>
                      {t("pre11")}
                    </a>
                  )}


              </div>
              <div className="main-bottom-ahead">
                <div className="single-box activee">
                  <div className="upper-content">
                    <div className="d-flex justify-content-between align-item-center">
                      <h6 style={{ color: "#E88F35" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                        >
                          <path
                            d="M20.5834 3.25H5.41675L2.16675 9.75L13.0001 22.75L23.8334 9.75L20.5834 3.25ZM10.4217 8.66667L12.0467 5.41667H13.9534L15.5784 8.66667H10.4217ZM11.9167 10.8333V18.07L5.89341 10.8333H11.9167ZM14.0834 10.8333H20.1067L14.0834 18.07V10.8333ZM20.8651 8.66667H17.9942L16.3692 5.41667H19.2401L20.8651 8.66667ZM6.76008 5.41667H9.63092L8.00591 8.66667H5.13508L6.76008 5.41667Z"
                            fill="#E89735"
                          />
                        </svg>
                        {t("GemsPremium")}
                      </h6>
                      {account &&
                        subscriptionData?.length > 0 &&
                        moment().isAfter(subscriptionEndTime) &&
                        stakingData?.length > 0 &&
                        subscriptionEndTime.isAfter(stakeEndTime) ? (
                        <p
                          className="cdhbdybydbcy"
                          style={{ color: "#FF4A4A" }}
                        >
                          {t("pre12")}{" "}
                          {moment(subscriptionEndTime)?.format("DD/MM/YY")}
                        </p>
                      ) : subscriptionData?.length > 0 &&
                        moment() > subscriptionEndTime &&
                        stakingData?.length > 0 &&
                        moment().isAfter(stakeEndTime) &&
                        stakingData[stakingData.length - 1]?.isClaimed ==
                        false ? (
                        <p
                          className="cdhbdybydbcy"
                          style={{ color: "#FF4A4A" }}
                        >
                          {t("pre12")}{" "}
                          {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      ) : null}
                    </div>
                    {/*     <h4>
                       <span>$400</span>{" "}
                      <div className="rightstyle">
                        <span className="yeartext">/year </span>{" "}
                       <span className="paidtext">Paid in $GEMS</span> 
                      </div>
                    </h4>*/}
                    <h3 className="mainheading">
                      {/* <span className="cutfour">$400</span> */}
                      $400
                      <div className="righthead">
                        {/* <span className="limited">{t("pre13")}</span> */}
                        <p className="yearpara">/{t("Cre30")} </p>
                      </div>
                    </h3>
                  </div>
                  <div className="bottom-content">
                    <div className="inner-single singlearea">
                      <div
                        className="text"
                        style={{ justifyContent: "flex-start" }}
                      >
                        <p style={{ color: "var(--btn-green-bg)" }}>
                          Launchpad
                        </p>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>{t("pre5")}</p>
                      </div>
                      <div className="text">
                        <span className="greentext">20%</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>{t("pre6")}</p>
                      </div>
                      <div className="text">
                        <span className="greentext">7%</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>
                          {t("pre7")}{" "}
                          <span className="orange-text">{t("Cryptot5")}</span>
                        </p>
                      </div>
                      <div className="text">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M14.5 6.12139L14.5 0.5L5.72892 9.04331L0.5 5.44118L0.5 10.6526L5.72892 14.5L14.5 6.12139Z"
                            fill="#329879"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>
                          {t("CreditRefund")}{" "}
                          <span className="orange-text">{t("Cryptot5")}</span>
                        </p>
                      </div>
                      <div className="text">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <path
                            d="M14.5 6.12139L14.5 0.5L5.72892 9.04331L0.5 5.44118L0.5 10.6526L5.72892 14.5L14.5 6.12139Z"
                            fill="#329879"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="inner-single singlearea">
                      <div
                        className="text"
                        style={{ justifyContent: "flex-start" }}
                      >
                        <p style={{ color: "var(--btn-green-bg)" }}>
                          {t("Footernew22")}
                        </p>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>{t("pre8")}</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p> {t("pre9")}</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>{t("pre10")}</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                  </div>

                  {!isPremium && (
                    <div className="dropdown dropdownstakingtoken">
                      <button
                        className="dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <div className="leftdrop">
                          {t("pre14")}{" "}
                          <img
                            src={`/assets/staking/${token.tokenImg}.svg`}
                            alt="img"
                            className="img-fluid"
                          />{" "}
                          <span>{token?.NAME}</span>
                        </div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="7"
                          viewBox="0 0 15 7"
                          fill="none"
                        >
                          <path
                            d="M0.535156 0L0.535157 2.97056L7.76848 7L7.76848 4.02943L0.535156 0Z"
                            fill="#02171D"
                          />
                          <path
                            d="M15 0.00012207L15 2.97068L7.76667 7.00012L7.76667 4.02955L15 0.00012207Z"
                            fill="#02171D"
                          />
                        </svg>
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        {TOKENS.map((token) => (
                          <li key={token.tokenImg}>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={() => setToken(token)}
                            >
                              <img
                                src={`/assets/staking/${token.tokenImg}.svg`}
                                alt={token.NAME}
                                className="img-fluid"
                              />
                              {token.NAME}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {account ? (
                    <>
                      {(() => {
                        const isSubscriptionActive =
                          subscriptionData?.length > 0 &&
                          moment().isBefore(subscriptionEndTime);

                        const isStakingActive =
                          stakingData?.length > 0 &&
                          moment().isBefore(stakeEndTime) &&
                          stakedAmount >= 5555;

                        const isPremiumActive =
                          isPremium;

                        const hasActiveStaking =
                          stakingData?.length > 0 &&
                          stakingData[stakingData.length - 1]?.isClaimed === false;

                        // ✅ Case 1: If user has unclaimed staking + staked enough → show premium plan (force isPremiumActive UI)
                        if (stakedAmount >= 5555 && hasActiveStaking) {
                          return (
                            <a
                              className="btn-plan activee planwhenactivenewbox"
                              style={{ justifyContent: "space-between" }}
                            >
                              <h6>{t("pre11")}</h6>
                              {/* <p>
                                {t("pre16")}{" "}
                                {moment(stakeEndTime)?.format("DD/MM/YY")}
                              </p> */}
                            </a>
                          );
                        }

                        // ✅ Case 2: No active premium (no subscription, insufficient staking, or expired)
                        if (!isPremiumActive && stakedAmount < 5555) {
                          return (
                            <button
                              id="1"
                              className="btn-plan activee"
                              onClick={() => handleShow()}
                            >
                              {t("pre15")}
                            </button>
                          );
                        }

                        // ✅ Case 3: Active premium (valid subscription or sufficient staking)
                        if (isPremiumActive) {
                          return (

                            <>
                              <a
                                className="btn-plan activee planwhenactivenewbox"
                                style={{ justifyContent: "space-between" }}
                              >

                                <h6>{t("pre11")}</h6>
                                <p>
                                  {subscriptionEndTime ? t("pre16") : null}{" "}
                                  {console.log(isSubscriptionActive, subscriptionEndTime, 'subscriptionEndTimesubscriptionEndTime')}
                                  {isSubscriptionActive && subscriptionEndTime
                                    ? moment(subscriptionEndTime)?.format("DD/MM/YY")
                                    : null}
                                </p>
                              </a>

                            </>
                          );
                        }

                        // ✅ Case 4: Default case - no subscription
                        return (
                          <div className="twice-btns" style={{ gap: "10px" }}>
                            <a className="upgrade-gems" onClick={() => handleShow()}>
                              {t("pre15")}
                            </a>
                          </div>
                        );
                      })()}
                    </>
                  ) : (
                    <a onClick={() => setShow_Nav(true)} className="btn-plan activee">
                      {t("pre18")}
                    </a>
                  )}


                  {/* <div className="twice-content-staking">
                    <p>Balance:</p>
                    <h6>23,145.45 ETH (~$687.34)</h6>
                  </div> */}
                  {account &&
                    stakingData?.length > 0 &&
                    stakedAmount >= 5555 && (
                      <Accordion
                        defaultActiveKey="0"
                        className="withdrawaccordion"
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="26"
                              height="26"
                              viewBox="0 0 26 26"
                              fill="none"
                            >
                              <path
                                d="M20.5832 3.25H5.4165L2.1665 9.75L12.9998 22.75L23.8332 9.75L20.5832 3.25ZM10.4215 8.66667L12.0465 5.41667H13.9532L15.5782 8.66667H10.4215ZM11.9165 10.8333V18.07L5.89317 10.8333H11.9165ZM14.0832 10.8333H20.1065L14.0832 18.07V10.8333ZM20.8648 8.66667H17.994L16.369 5.41667H19.2398L20.8648 8.66667ZM6.75984 5.41667H9.63067L8.00567 8.66667H5.13484L6.75984 5.41667Z"
                                fill="#E89735"
                              />
                            </svg>
                            {t("pre19")}
                          </Accordion.Header>
                          <Accordion.Body>
                            <p className="accpara">{t("pre20")}</p>
                            <p className="accpara mb-0">
                              {t("pre21")}{" "}
                              <span className="bolder">{t("pre22")}</span>,{" "}
                              {t("pre23")}{" "}
                              <span className="bolder">{t("pre24")}</span>
                            </p>

                            {moment().isAfter(stakeEndTime) && (
                              <button
                                className="withdrawbtn"
                                onClick={() => {
                                  unstake(stakeIndex);
                                }}
                              >
                                {t("pre25")} {stakedAmount?.toLocaleString()}{" "}
                                GEMS
                              </button>
                            )}

                            {moment().isBefore(stakeEndTime) && (
                              <p className="lastparaacc">
                                {t("pre26")}{" "}
                                {moment(stakeEndTime)?.format("DD/MM/YY")}
                              </p>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    )}
                  {/* <a href="#" className="btn-plan" style={{ flexDirection: "column" }}>
                                        <h6>{t('pre11')}</h6>
                                        <p>expires on 6/07/24</p>
                                    </a> */}
                  {/* <div className="twice-btns">
                                        <a href="#" className="withdraw-gems">
                                            Withdraw Gems
                                        </a>
                                        <a href="#" className="upgrade-gems">
                                            upgrade Again
                                        </a>
                                    </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        className="common-modal-style stakingmodal premiumstake-modal"
        show={show1}
        onHide={handleClose}
        centered
        style={{ zIndex: "9999999999999999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title> {t("pre15")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\staking\modalbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\staking\premiumsvg.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>{t("pre27")}</h5>
              {/* <p>
                You will be paying $400 in $GEMS to enjoy <br /> 1 year of
                discounted purchases.
              </p> */}
            </div>
            <div className="d-flex justify-content-center mb-4">
              {/* <p className="text-danger ">{walletError}</p> */}
            </div>
            <div className="stakingbtns">
              <button
                onClick={() => {
                  handleClose();
                }}
                className="cancelbtn"
              >
                {t("pre28")}
              </button>
              <button
                onClick={() => {
                  Stake();
                  // handleShow()
                }}
                className="confirmbtn"
              >
                {t("pre29")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="common-modal-style stakingmodal"
        show={show2}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("pre30")}!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
            >
              <path
                d="M40 77.8947C60.9286 77.8947 77.8947 60.9286 77.8947 40C77.8947 19.0713 60.9286 2.10522 40 2.10522C19.0713 2.10522 2.10522 19.0713 2.10522 40C2.10522 60.9286 19.0713 77.8947 40 77.8947Z"
                fill="#329879"
              />
              <path
                d="M36.1262 54.3997C35.5788 54.3997 35.0315 54.1892 34.6525 53.7681L22.9473 42.0629C22.1051 41.2208 22.1051 39.9155 22.9473 39.0734C23.7894 38.2313 25.0946 38.2313 25.9367 39.0734L35.9999 49.1366L54.0209 26.3997C54.7367 25.4734 56.0841 25.3471 56.9683 26.0629C57.8946 26.7787 58.0209 28.126 57.3051 29.0102L37.8104 53.5997C37.4315 54.0629 36.8841 54.3576 36.2946 54.3997C36.2104 54.3997 36.1683 54.3997 36.1262 54.3997Z"
                fill="#E2E9EC"
              />
            </svg>
            <h6 className="successhead">{t("pre31")}</h6>
            <p className="succesaspara">{t("pre32")}</p>
            <button
              className="btn-green w-100"
              onClick={() => {
                handleClose1();
              }}
            >
              OK
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="common-modal-style stakingmodal"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("pre30")}!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
            >
              <path
                d="M40 77.8947C60.9286 77.8947 77.8947 60.9286 77.8947 40C77.8947 19.0713 60.9286 2.10522 40 2.10522C19.0713 2.10522 2.10522 19.0713 2.10522 40C2.10522 60.9286 19.0713 77.8947 40 77.8947Z"
                fill="#329879"
              />
              <path
                d="M36.1262 54.3997C35.5788 54.3997 35.0315 54.1892 34.6525 53.7681L22.9473 42.0629C22.1051 41.2208 22.1051 39.9155 22.9473 39.0734C23.7894 38.2313 25.0946 38.2313 25.9367 39.0734L35.9999 49.1366L54.0209 26.3997C54.7367 25.4734 56.0841 25.3471 56.9683 26.0629C57.8946 26.7787 58.0209 28.126 57.3051 29.0102L37.8104 53.5997C37.4315 54.0629 36.8841 54.3576 36.2946 54.3997C36.2104 54.3997 36.1683 54.3997 36.1262 54.3997Z"
                fill="#E2E9EC"
              />
            </svg>
            <h6 className="successhead">
              {stakedAmount?.toLocaleString()} {t("pre33")}
            </h6>
            <p className="succesaspara">{t("pre34")}</p>
            <button
              className="btn-green w-100"
              onClick={() => {
                handleClose3();
              }}
            >
              OK
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="common-modal-style followusonx-modal verificationemail-modal"
        show={showverify}
        onHide={handleCloseVerify}
        centered
        backdrop="static" // prevents closing on outside click
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="verification-modal">
            <p className="para">
              We will email you a 6-digit code to verify your email address.
              Enter the code below.
            </p>

            <div className="option-field">
              <label>Email Address</label>
              <div className="inside-input">
                <input
                  type="text"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={handleEmailChange}
                />
                <a
                  href="#"
                  className={`btn-send ${!isEmailValid || isResendDisabled ? "disabled" : ""
                    }`}
                  onClick={handleSendCode}
                  style={{
                    pointerEvents:
                      !isEmailValid || isResendDisabled ? "none" : "auto",
                    opacity: !isEmailValid || isResendDisabled ? 0.5 : 1,
                  }}
                >
                  {isResendDisabled ? `Resend in ${timer}s` : "Send Code"}
                </a>
              </div>
            </div>

            <div
              style={{
                opacity: showOtpInput ? 1 : 0.5,
                pointerEvents: showOtpInput ? "auto" : "none",
              }}
            >
              <div className="option-field" style={{ marginTop: "25px" }}>
                <label
                  style={{ color: "var(--V6-Dark-Theme-Secondary-Text-Color)" }}
                >
                  Verification Code
                </label>
                <div className="inside-input">
                  <input
                    type="text"
                    placeholder="Enter 6-digit code here"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>
              </div>

              {!isOtpValid && (
                <p className="error-text">Invalid email verification code</p>
              )}

              <div className="twice-btnsss">
                <button
                  className={`btn-green sscscscscscsc ${otp.length !== 6 ? "disabled" : ""
                    }`}
                  style={{ marginTop: "28px" }}
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 6}
                >
                  Verify Code
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="common-modal-style followusonx-modal"
        show={show5}
        onHide={handleClose5}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("pre35")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal buynft-modal2">
            <img
              src="\assets\staking\followx.svg"
              alt="img"
              className="img-fluid d-none show-in-light-theme"
            />
            <img
              src="\assets\staking\followx-dark.svg"
              alt="img"
              className="img-fluid hide-in-light-theme"
            />
            <h4>{t("pre36")}</h4>
            <p className="newdeisgnpara">{t("pre37")} </p>
          </div>
          <div className="twice-btnsss">
            <button
              onClick={twitterHandler}
              className="btn-green sscscscscscsc"
            >
              {t("pre36")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Staking;
